import React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Stack
} from "../../../components/mui";
import { SearchRoundedIcon, RestartAltRoundedIcon } from "../../../components/icons";
import Modal from "../../../components/shared/Modal";

export default function OccupantsHistoryModal({ open, onClose, unitData }) {
  // Hardcoded data - Backend developer will replace with API calls
  const occupantsData = [
    {
      eid: "VT027",
      fullName: "Chi Kien Trinh",
      gender: "M",
      ranking: "0",
      designation: "Operations Analyst",
      company: "Caspo Inc",
      division: "Operations Management",
      department: "RB",
      team: "America",
      nationality: "Vietnamese"
    }
  ];

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
    </>
  );

  const modalTitle = unitData 
    ? `${unitData.unit} - ${unitData.condo} Occupant History`
    : "Occupant History";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={modalTitle}
      actions={actions}
      maxWidth="lg"
      fullWidth
    >
      <div className="modal-form-grid">
        {/* Filters Section */}
        <Box className="modal-filters">
          <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Year</InputLabel>
              <Select
                defaultValue="2025"
                label="Year"
              >
                <MenuItem value="2025">2025</MenuItem>
                <MenuItem value="2024">2024</MenuItem>
                <MenuItem value="2023">2023</MenuItem>
                <MenuItem value="2022">2022</MenuItem>
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Month</InputLabel>
              <Select
                defaultValue="October"
                label="Month"
              >
                <MenuItem value="January">January</MenuItem>
                <MenuItem value="February">February</MenuItem>
                <MenuItem value="March">March</MenuItem>
                <MenuItem value="April">April</MenuItem>
                <MenuItem value="May">May</MenuItem>
                <MenuItem value="June">June</MenuItem>
                <MenuItem value="July">July</MenuItem>
                <MenuItem value="August">August</MenuItem>
                <MenuItem value="September">September</MenuItem>
                <MenuItem value="October">October</MenuItem>
                <MenuItem value="November">November</MenuItem>
                <MenuItem value="December">December</MenuItem>
              </Select>
            </FormControl>

            <Button
              variant="outlined"
              size="small"
              startIcon={<RestartAltRoundedIcon />}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              size="small"
              startIcon={<SearchRoundedIcon />}
            >
              Search
            </Button>
          </Stack>
        </Box>

        {/* Show Entries */}
        <Box className="modal-show-entries">
          <Stack direction="row" spacing={1} alignItems="center">
            <span className="modal-show-entries-text">Show</span>
            <FormControl size="small" sx={{ minWidth: 80 }}>
              <Select defaultValue={30}>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={30}>30</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
            <span className="modal-show-entries-text">entries</span>
          </Stack>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} className="modal-table-container">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell className="modal-table-header">EID</TableCell>
                <TableCell className="modal-table-header">Full Name</TableCell>
                <TableCell className="modal-table-header">Gender</TableCell>
                <TableCell className="modal-table-header">Ranking</TableCell>
                <TableCell className="modal-table-header">Designation</TableCell>
                <TableCell className="modal-table-header">Company</TableCell>
                <TableCell className="modal-table-header">Division</TableCell>
                <TableCell className="modal-table-header">Department</TableCell>
                <TableCell className="modal-table-header">Team</TableCell>
                <TableCell className="modal-table-header">Nationality</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {occupantsData.map((occupant, index) => (
                <TableRow key={index}>
                  <TableCell className="modal-table-cell">{occupant.eid}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.fullName}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.gender}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.ranking}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.designation}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.company}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.division}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.department}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.team}</TableCell>
                  <TableCell className="modal-table-cell">{occupant.nationality}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Info */}
        <Box className="modal-pagination-info">
          <span className="modal-pagination-text">
            Showing 1 to 1 of 1 entries
          </span>
        </Box>
      </div>
    </Modal>
  );
}
